import $ from 'jquery';
import $script from 'scriptjs';
import layout from '../Layout';
import ProductQuickshop from './ProductQuickshop';
import AddToCartFlyout from './AddToCartFlyout';

export default class ProductGridItem {
  constructor(options) {
    this.$el = options.$el;
    this.id = options.id;
    this.productQuickshop = null;
    this.quickBuySettings = null;
    this.events = [];
    this.actionsOpen = false;

    this.$window = $(window);
    this.$html = $('html');
    this.$content = this.$el.find('[data-product-item-content]');
    this.$actions = this.$el.find('[data-product-actions]');
    this.hasProductActions = this.$actions.length;

    this._addToCart = this._addToCart.bind(this);
    this._actionsToggle = this._actionsToggle.bind(this);

    if (this.hasProductActions) {
      this._setSortByQueryParameters();

      if (this.$html.hasClass('no-touch') && Shopify.queryParams.grid_list !== 'list-view') {
        this.events.push(this.$el.on('mouseenter.product-item', this._actionsToggle));
        this.events.push(this.$el.on('mouseleave.product-item', this._actionsToggle));
        this.events.push(this.$el.on('focusin.product-item', this._actionsToggle));
      }

      // $scripts checks existence of script in header before attempting to inject
      $script($('[data-scripts]').data('shopify-api-url'), () => {
        this.events.push(this.$el.on('click.product-item', '[data-quick-buy]', this._addToCart));
      });
    }

    if (this.$el.find('[data-quick-buy]').length) {
      this._initQuickBuy();
    }

    // Stock Label
    this._initStockLabel(options);

    this._objectFitPolyfill();
  }

  // PS Stock Label
  _initStockLabel(options) {

    // Product -> Relate Product - inject
    let $stock = this.$el.find('.productitem--stock'), $tmp = $('[relate-product-tmp]'), vendor, 
      targetText = '<!-- Product Stock Label -->';
    // Check if empty
    if ($stock.length == 0 || $stock.data('vendor') === undefined) {
      return;
    }
    vendor = $stock.data('vendor').trim();
    if ($stock.html().includes(targetText) && $tmp.length) {
      $stock.html($stock.html().replace(targetText, $tmp.first().html()));
    }
    if (!$stock.length || vendor === null) {
      return;
    }
    // Do nothing
    if ($stock.data('qty') == 'undefined') return;
    if (parseInt($stock.data('qty')) >= 1) {
      $stock.find('.in-stock-block').removeClass('hidden');
    } else {
      // soldout_contact_order 
      if ($stock.data('tag') == 'soldout_contact_order') {
        if ($stock.find('.sold-out-contact-order.have-tag') !== null) {
          $stock.find('.sold-out-contact-order.have-tag').each(function (i, item) {
            let vendors = item.getAttribute('data-vendor').split('|').map(function (e) { return e.trim() });
            if (vendors.indexOf(vendor) !== -1) {
              $(item).removeClass('hidden');
            }
          });
          $stock.find('.out-stock-block').each(function (i, item) {
            let vendors = item.getAttribute('data-vendor').split('|').map(function (e) { return e.trim() });
            if (vendors.indexOf(vendor) !== -1) {
              $(item).addClass('hidden');
            }
          });
        }
      } else {
        $stock.find('.out-stock-block').each(function (i, item) {
          let vendors = item.getAttribute('data-vendor').split('|').map(function (e) { return e.trim() });
          if (vendors.indexOf(vendor) !== -1) {
            $(item).removeClass('hidden');
          }
        });
      }
      // if ($stock.find('.sold-out-contact-order') !== null) {
      //   $stock.find('.sold-out-contact-order').each(function (i, item) {
      //     let vendors = item.getAttribute('data-vendor').split('|').map(function (e) { return e.trim() });
      //     if (vendors.indexOf(vendor) !== -1) {
      //       $(item).addClass('hidden');
      //     }
      //   });
      // }
    }
  }

  /**
   * Make Shopify aware of releavent collection search info
   *  - tag
   *  - vendor
   *  - pagination
   *  - sorting criteria
   *
   * @private
   */
  _setSortByQueryParameters() {
    Shopify.queryParams = {};
    if (location.search.length) {
      for (let i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
        const aKeyValue = aCouples[i].split('=');
        // Reset the page number when we apply (i.e. don't add it to params)
        if (aKeyValue.length > 1 && aKeyValue[0] !== 'page') {
          Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
        }
      }
    }
  }

  _initQuickBuy() {
    try {
      this.quickBuySettings = JSON.parse(this.$el.find('[data-quick-buy-settings]').text());
    } catch (error) {
      return console.warn(`Quick buy: invalid QuickBuy data found. ${error.message}`);
    }
  }

  _openQuickShop(event) {
    event.preventDefault();

    const modalClass = event.currentTarget.hasAttribute('data-quickshop-full')
      ? 'quickshop-full'
      : 'quickshop-slim';

    if (this.productQuickshop) {
      this.productQuickshop.unload();
    }

    this.productQuickshop = new ProductQuickshop({
      $el: this.$el,
      id: this.id,
      modalClass,
      trigger: this.$el.find('.productitem--title a'),
    });
  }

  _isObjectFitAvailable() {
    return 'objectFit' in document.documentElement.style;
  }

  _objectFitPolyfill() {
    if (this._isObjectFitAvailable()) {
      return;
    }

    const $figure = $('[data-product-item-image]', this.$el);
    const featuredSrc = $('img:not(.productitem--image-alternate)', $figure).attr('src');
    const alternateSrc = $('.productitem--image-alternate', $figure).attr('src');

    $figure.addClass('product-item-image-no-objectfit');
    $figure.css('background-image', `url("${ featuredSrc }")`);

    if(alternateSrc) {
      this.$el.on("mouseover", () => {
        $figure.css('background-image', `url("${ alternateSrc }")`);
      });

      this.$el.on("mouseleave", () => {
        $figure.css('background-image', `url("${ featuredSrc }")`);
      });
    }
  }

  /**
   * Get height of element, and combined height of element + actions
   *
   * @returns {{heightBase, heightExpanded: *}}
   * @private
   */
  _getHeights() {
    const height = this.$el.height();
    const actionsHeight = this.$el.find('[data-product-actions]').outerHeight(true);

    return {
      heightBase: height,
      heightExpanded : height + actionsHeight,
    };
  }

  _actionsToggle(event) {
    if (!layout.isBreakpoint('L')) return;

    const $currentTarget = $(event.currentTarget);
    const $target = $(event.target);

    let openProductItem = false;

    // This function gets called on the element as well as the document focusin, so we want to
    // be extra careful that we are inside the product card in question. We want the product card
    // to close if another product card has received focus.
    const productHasFocus = this.$el.is($currentTarget)
      || this.$el.is($target)
      || this.$el.is($target.parents('.productgrid--item').first());

    if (event.type === 'mouseenter' || event.type === 'mouseleave') {
      openProductItem = event.type === 'mouseenter';
    } else if (productHasFocus) {
      openProductItem = true;
    }

    if (openProductItem) {
      this._showActions();
    } else {
      this._hideActions();
    }
  }

  _showActions() {
    if (this.actionsOpen) { return; }

    const { heightBase, heightExpanded } = this._getHeights();

    // Lock heights to prevent jumping
    this.$el.css('height', heightBase);
    this.$content.css('height', heightBase);

    // Store height for when hovering out
    this.$el.data('base-height', heightBase);

    // Start animation, and transition height to expanded height
    this.$el
      .revealer('show')
      .one('revealer-animating.product-item', () => {
        this.$content.css('height', heightExpanded);
      });

    document.addEventListener('focusin', this._actionsToggle);

    this.actionsOpen = true;
  }

  _hideActions() {
    const height = this.$el.data('base-height');

    /*
      - Transition buttons up, using base height for animation
      - Remove heights after animation is complete in case of resize
     */
    this.$el
      .revealer('hide')
      .one('revealer-animating', () => {
        this.$el.off('revealer-animating.product-item');
        this.$el.css({ height });
        this.$content.css({ height });
      }).one('revealer-hide', () => {
        this.$el
          .off('revealer-hide.product-item')
          .css('height', '');
        this.$content.css('height', '');
      });

    document.removeEventListener('focusin', this._actionsToggle);

    this.actionsOpen = false;
  }

  _addToCart(event) {
    event.preventDefault();
    const $atcButton = $(event.currentTarget);
    const variantID = $atcButton.attr('data-variant-id');

    const formData = [
      {
        'name': 'id',
        'value': variantID,
      },
      {
        'name': 'quantity',
        'value': 1,
      },
    ];

    const options = {
      $atcButton,
      settings: {
        moneyFormat: this.quickBuySettings.money_format,
        cartRedirection: this.quickBuySettings.cart_redirection,
      },
    };

    AddToCartFlyout.init(formData, options);
  }

  unload() {
    this.events.forEach($el => $el.off('.product-item'));

    if (this.productQuickshop) {
      this.productQuickshop.unload();
    }

    document.removeEventListener('focusin', this._actionsToggle);
  }
}
